<template>
  <div class="tabbar5">
    <!-- <img class="img" src="~@/assets/images/wd.png" alt />
    <div class="div">
      <img src="~@/assets/images/jdon.png" alt />
    </div>-->
  </div>
</template>
<script>
import data from "@/data/tabbar5_data.js";
// const show1 = () => import("@/components/show/show1.vue");
export default {
  name: "tabbar5",
  components: {
    // 组件注册
    // show1
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
    // Vue实例渲染完成后执行
  }
};
</script>
<style scoped lang="scss">
@import url("~@/assets/icon/iconfont.css");
// .img {
//   width: 100%;
//   height: 30rem;
// }
.div {
  width: 100%;
  height: 3.3rem;
  background-color: #f7f7f7;
  text-align: center;
  line-height: 3.3rem;
  margin-top: -0.3rem;
  img {
    width: 5rem;
    height: 1rem;
  }
}
</style>
